import { DialogContent, DialogTitle, Grid, Stack } from '@mui/material';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { createNewCurrency } from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsButton, Label, WsSelect } from 'wisestep-base';

import { CurrencyTypeDropDownOptions } from '../../../utils';
import { failed, success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { currencySettingsDefaultQuery } from '../helper/ClientSettingsHelper';

const CurrencyForm = ({ onSave, onCancel }) => {
  const methods = useForm();
  const { handleSubmit } = methods;
  const setNotification = useNotificationStore((state) => state.setNotification);

  const onSubmit = async (data: FieldValues) => {
    const payload = { ...currencySettingsDefaultQuery };
    payload.symbol = data.symbol;

    try {
      const response = await createNewCurrency(payload);
      setNotification(success('Currency has been added successfully !!'));
      onSave(response.data);
    } catch (error: any) {
      if (error.response.status === 400)
        setNotification(warning(`${data.symbol} : Hey I am already in the list!!`));
      else setNotification(failed('Something went wrong !!'));
    }
  };

  return (
    <>
      <DialogTitle>
        <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
          Client Currencies
        </WsTypography>
      </DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <Grid container direction={'column'} xs={12} spacing={2}>
            <Grid item xs={12}>
              <Label sx={{ mb: '1vw' }}>Choose currency:</Label>
              <WsSelect name="symbol" selectArray={CurrencyTypeDropDownOptions} />
            </Grid>
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                <WsButton variant="outlined" size="large" onClick={onCancel}>
                  Close
                </WsButton>
                <WsButton type="submit" size="large" onClick={handleSubmit(onSubmit)}>
                  Save
                </WsButton>
              </Stack>
            </Grid>
          </Grid>
        </FormProvider>
      </DialogContent>
    </>
  );
};

export default CurrencyForm;
